<template>
  <div class="">
    <div class="text-small text-gray pb-8">
      <a href="/admin">Admin</a> > System Configuration
    </div>
    <div class="flex justify-between items-center mb-5">
      <h2 class="text-primary-500 mb-0">
        System Configuration
      </h2>
    </div>
    <d-tabs v-model="activeTab">
      <d-tab-item label="Resource Categories">
        <resource-categories-table />
      </d-tab-item>
      <d-tab-item label="Assignment Categories">
        <assignment-categories-table />
      </d-tab-item>
      <d-tab-item label="Emphases">
        <emphases-table />
      </d-tab-item>
      <d-tab-item label="Pathways">
        <pathways-table />
      </d-tab-item>
      <d-tab-item label="Programs">
        <programs-table />
      </d-tab-item>
      <d-tab-item label="Flex Fields">
        <flex-fields-table />
      </d-tab-item>
      <d-tab-item label="Custom Nav Links">
        <nav-links-table />
      </d-tab-item>
    </d-tabs>
  </div>
</template>

<script>
  import AssignmentCategoriesTable from './components/SystemConfig/AssignmentCategoriesTable.vue';
  import ResourceCategoriesTable from './components/SystemConfig/ResourceCategoriesTable.vue';
  import EmphasesTable from './components/SystemConfig/EmphasesTable.vue';
  import PathwaysTable from './components/SystemConfig/PathwaysTable.vue';
  import ProgramsTable from './components/SystemConfig/ProgramsTable.vue';
  import FlexFieldsTable from './components/SystemConfig/FlexFieldsTable.vue';
  import NavLinksTable from './components/SystemConfig/NavLinksTable.vue';

  export default {
    parent: true,
    components: {
      AssignmentCategoriesTable,
      ResourceCategoriesTable,
      EmphasesTable,
      PathwaysTable,
      ProgramsTable,
      FlexFieldsTable,
      NavLinksTable,
    },

    data: () => ({
      activeTab: 0,
    }),
  };
</script>